import { Navigate } from "react-router-dom";
import { isLogin } from "./token-check";

const PublicRoute = ({
  component: Component,
  restricted = false,
  redirectTo = "/home",
  ...rest
}) => {
  const loggedIn = isLogin();
  return loggedIn && restricted ? (
    <Navigate to={redirectTo} replace />
  ) : (
    <Component {...rest} />
  );
};

export default PublicRoute;
